import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import { toWidget } from '@ckeditor/ckeditor5-widget';
import InsertResumeExampleCommand from './resume-example-command';
export default class ResumeExampleEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertResumeExample', new InsertResumeExampleCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('resumeExample', {
            isObject: true,
            allowWhere: '$block',
            allowAttributes: ['exampleId', 'userId'],
        });
        schema.register('resumeExampleTitle', {
            isLimit: true,
            allowIn: 'resumeExample',
            allowContentOf: '$block',
        });
        schema.register('resumeExampleDescription', {
            isLimit: true,
            allowIn: 'resumeExample',
            allowContentOf: '$block',
        });
    }
    _defineConverters() {
        try {
            const conversion = this.editor.conversion;
            // resume example container
            conversion.for('upcast').elementToElement({
                model: (viewElement, { writer }) => {
                    return writer.createElement('resumeExample', {
                        exampleId: viewElement.getAttribute('data-example-id'),
                        userId: viewElement.getAttribute('data-user-id'),
                    });
                },
                view: { name: 'x-resume-example' },
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'resumeExample',
                view: (modelElement, { writer }) => {
                    return writer.createContainerElement('x-resume-example', {
                        'data-example-id': modelElement.getAttribute('exampleId'),
                        'data-user-id': modelElement.getAttribute('userId'),
                    });
                },
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'resumeExample',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'resume-example',
                        'data-example-id': model.getAttribute('exampleId'),
                        'data-user-id': model.getAttribute('userId'),
                    });
                    return toWidget(element, writer, { label: 'resume example' });
                },
            });
            // resume example title
            conversion.for('upcast').elementToElement({
                model: 'resumeExampleTitle',
                view: 'x-resume-example-title',
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'resumeExampleTitle',
                view: 'x-resume-example-title',
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'resumeExampleTitle',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'resume-example__title',
                    });
                    return element;
                },
            });
            // resume example description
            conversion.for('upcast').elementToElement({
                model: 'resumeExampleDescription',
                view: 'x-resume-example-description',
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'resumeExampleDescription',
                view: 'x-resume-example-description',
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'resumeExampleDescription',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'resume-example__description',
                    });
                    return element;
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
}
